import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * The payload itself is the problem, in a way the validator could not see: a field the schema
 * allows that this write cannot take, two values that contradict each other, a body that says
 * nothing. Nothing has moved under the caller — the same request will be refused again.
 * 400, code `bad_request`.
 */
export class BadRequestError extends LocalizedError {
	readonly status = 400 as const;
	readonly code: string;

	constructor(key: TranslationKey, options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "BadRequestError";
		this.code = options?.code ?? "bad_request";
	}
}
